var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',[_c('span',{staticClass:"left-btn"}),_c('span',{staticClass:"header-title title3"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('button',{staticClass:"right-btn",attrs:{"type":"button"},on:{"click":_vm.closeBtnClicked}},[_c('span',{staticClass:"material-icons"},[_vm._v("close")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }